import { nanoid } from '@w/id'
import { isProd, isTest } from './is-env.js'

export function generate<T = number>(
  length: number,
  cb: (index: number) => T = (i: number) => i as T,
): T[] {
  return Array.from({ length }, (_, i) => cb(i))
}

export function safe<T>(value: T | undefined | null, message = 'Value is undefined or null'): T {
  if (value === undefined || value === null) {
    if (!isProd && !isTest) {
      // biome-ignore lint/suspicious/noDebugger: <explanation>
      debugger // do not remove
    }
    throw new Error(message)
  }
  return value
}

export const isSafe = <T>(value: T | undefined | null): value is T => {
  return value !== undefined && value !== null
}

export function unknownErrorToError(error: unknown): Error {
  if (error instanceof Error) return error
  return new Error(String(error))
}

export const makeCounter = () => {
  let count = 0
  return () => ++count
}

export const uid = nanoid
export const uid10 = () => nanoid(10) // if we need uid to be shorter due to db constraints

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function withLogging<TArgs extends any[], TResult>(
  fn: (...args: TArgs) => TResult, // Original function can be sync or async
): (...args: TArgs) => TResult {
  const fnName = fn.name

  return (...args: TArgs) => {
    console.info(`[${fnName}] args:`, ...args)
    const result = fn(...args)
    console.info(`[${fnName}] result:`, result)
    return result
  }
}

export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
